import React, { useState } from "react";
import "./index.scss";
import block1 from "../../assets/img/block1.jpeg";
import block2 from "../../assets/img/block2.jpeg";

const ImageBlock = (props) => {
  const { imgUrl } = props;
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div className="image-hover">
      <div className="Container">
        <div className="image-hover-block">
          <div className="row justify-content-center">
            <div className="box">
              <img src={block1} />
              <div className="orerlay">
                <p>{"行业应用"}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="image-hover-block">
          <div className="row justify-content-center">
            <div className="box">
              <img src={block2} />
              <div className="orerlay">
                <p>{"品牌销售"}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="image-hover-block">
          <div className="row justify-content-center">
            <div className="box">
              <img src={block1} />
              <div className="orerlay">
                <p>{"行业应用"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <li class="slick-slide" style={{ width: "255px" }} tabindex="-1" role="option" aria-describedby="slick-slide10" data-slick-index="0" aria-hidden="true">
        <a href="http://www.starchain.com/html/zc/index.html" class="box" tabindex="-1">
          <i></i>
        <font>01</font>
          <div class="pic">
            <div class="img">
            <img src="http://www.starchain.com/uploadfile/202008/8328270f487261c.jpg" class="img01" />
            <img src="http://www.starchain.com/uploadfile/202008/c6e62ad18ce69c6.jpg" class="img02" />
            </div>
          </div>
        <h5>轴承</h5>
      </a>
    </li> */}

      {/* <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {isHovered ? (
        <img src="http://www.starchain.com/uploadfile/202008/c6e62ad18ce69c6.jpg" alt="Hovered Image" />
      ) : (
        <img src="http://www.starchain.com/uploadfile/202008/8328270f487261c.jpg" alt="Default Image" />
      )}
    </div> */}
    </div>
  );
};

export default ImageBlock;
